import React from 'react';
import { Link } from 'react-router-dom';
import { IoCall, IoLogoWhatsapp, IoSchool, IoPeople, IoTrophy, IoRibbon } from 'react-icons/io5';
import Card from '../../components/common/Card/Card';
import Button from '../../components/common/Button/Button';
import ImagePlaceholder from '../../components/common/ImagePlaceholder/ImagePlaceholder';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { APP_CONFIG } from '../../constants/config';
import './Admissions.css';

/**
 * Página de Admisión 2026 - Colegio Bertolt Brecht
 */
const Admissions = () => {
    return (
        <div className="admissions">
            {/* Page Header */}
            <PageHeader
                title="Admisión 2026"
                subtitle="¡Bienvenidos a un entorno educativo enfocado en el aprendizaje del estudiante!"
            />

            <div className="container">
                {/* Información de Contacto Destacada */}
                <section className="admissions__contact-highlight">
                    <Card className="admissions__contact-card">
                        <div className="admissions__contact-content">
                            <div className="admissions__contact-icon">
                                <IoSchool />
                            </div>
                            <div className="admissions__contact-info">
                                <h3>Información e Inscripciones</h3>
                                <p className="admissions__address">📍 {APP_CONFIG.contact.fullAddress}</p>
                                <div className="admissions__phones">
                                    {APP_CONFIG.contact.phones.map((phone, index) => (
                                        <a key={index} href={`tel:${phone.replace(/\s/g, '')}`} className="admissions__phone">
                                            📞 {phone}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Card>
                </section>

                {/* ¿Por qué elegirnos? */}
                <section className="admissions__why">
                    <h2 className="admissions__section-title">¿Por qué elegirnos?</h2>
                    <div className="admissions__why-grid">
                        <div className="admissions__why-item">
                            <div className="admissions__why-icon">
                                <IoTrophy />
                            </div>
                            <h3>Más de 20 años</h3>
                            <p>De experiencia formando estudiantes exitosos</p>
                        </div>
                        <div className="admissions__why-item">
                            <div className="admissions__why-icon">
                                <IoRibbon />
                            </div>
                            <h3>Metodología Propia</h3>
                            <p>Enfocada en el aprendizaje del estudiante</p>
                        </div>
                        <div className="admissions__why-item">
                            <div className="admissions__why-icon">
                                <IoSchool />
                            </div>
                            <h3>Desarrollo Integral</h3>
                            <p>Formación académica, personal y social</p>
                        </div>
                        <div className="admissions__why-item">
                            <div className="admissions__why-icon">
                                <IoPeople />
                            </div>
                            <h3>Equipo Profesional</h3>
                            <p>Docentes calificados y capacitados</p>
                        </div>
                    </div>
                </section>

                {/* Nuestro Equipo */}
                <section className="admissions__team">
                    <div className="admissions__team-content">
                        <div className="admissions__team-text">
                            <h2>Nuestro Equipo</h2>
                            <p>
                                Contamos con profesionales altamente calificados y capacitados, comprometidos con
                                la excelencia educativa y el desarrollo integral de cada estudiante.
                            </p>
                            <p>
                                Nuestros docentes están en constante actualización pedagógica para brindar la mejor
                                experiencia de aprendizaje a nuestros estudiantes.
                            </p>
                        </div>
                        <div className="admissions__team-visual">
                            <div className="admissions__team-circle admissions__team-circle--1"></div>
                            <div className="admissions__team-circle admissions__team-circle--2"></div>
                        </div>
                    </div>
                </section>

                {/* Niveles Disponibles */}
                <section className="admissions__levels">
                    <h2 className="admissions__section-title">Niveles Disponibles</h2>
                    <div className="admissions__levels-grid">
                        <Card hoverable className="admissions__level-card">
                            <ImagePlaceholder
                                aspectRatio="16/9"
                                icon="📚"
                                alt="Primaria"
                            />
                            <div className="admissions__level-content">
                                <h3>Primaria</h3>
                                <p>
                                    Educación primaria con metodología enfocada en el aprendizaje,
                                    desarrollo de habilidades fundamentales y acompañamiento personalizado.
                                </p>
                            </div>
                        </Card>

                        <Card hoverable className="admissions__level-card">
                            <ImagePlaceholder
                                aspectRatio="16/9"
                                icon="🎓"
                                alt="Secundaria"
                            />
                            <div className="admissions__level-content">
                                <h3>Secundaria</h3>
                                <p>
                                    Educación secundaria con currículo avanzado, orientación vocacional
                                    y preparación para exámenes de admisión universitaria.
                                </p>
                            </div>
                        </Card>
                    </div>
                </section>

                {/* Call to Action */}
                <section className="admissions__cta">
                    <div className="admissions__cta-content">
                        <h2>¿Listo para formar parte de nuestra familia educativa?</h2>
                        <p>Contáctanos ahora y conoce más sobre nuestro proceso de admisión</p>
                        <div className="admissions__cta-buttons">
                            <a href={`tel:${APP_CONFIG.contact.phones[0].replace(/\s/g, '')}`}>
                                <Button variant="primary" size="lg">
                                    <IoCall /> Llamar Ahora
                                </Button>
                            </a>
                            <a
                                href={`https://wa.me/51${APP_CONFIG.contact.phones[0].replace(/\s/g, '')}?text=Hola, me gustaría información sobre Admisión 2026`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Button variant="secondary" size="lg">
                                    <IoLogoWhatsapp /> WhatsApp
                                </Button>
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Admissions;
